/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon24Regular = forwardRef('LogoMicrosoftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V5Zm1.5 7.75V19c0 .69.56 1.25 1.25 1.25h6.25v-7.5h-7.5Zm7.5-1.5h-7.5V5c0-.69.56-1.25 1.25-1.25h6.25v7.5Zm1.5 1.5v7.5H19c.69 0 1.25-.56 1.25-1.25v-6.25h-7.5Zm7.5-1.5h-7.5v-7.5H19c.69 0 1.25.56 1.25 1.25v6.25Z" })));
});
